var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metafield-edit-text"},[_c('BaseTextarea',{attrs:{"data-vv-as":_vm.field.type,"minHeight":_vm.subFormData.rows * 25,"name":_vm.$attrs.name,"value":_vm.value,"label":_vm.field.label,"hint":_vm.hint,"validate":_vm.validator()},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d230f14","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/metafields-edit/metafields/MetafieldEditTextarea.vue
// module id = 679
// module chunks = 0